import type { IconData } from '@stacksjs/iconify-core'

export const chatBubbleOvalSmiley1Solid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 24C1.5 11.574 11.574 1.5 24 1.5S46.5 11.574 46.5 24S36.426 46.5 24 46.5a22.4 22.4 0 0 1-11.232-3c-2.466.91-5.259 1.805-8.01 2.45a2.305 2.305 0 0 1-2.807-2.71c.58-2.879 1.464-5.76 2.407-8.257A22.4 22.4 0 0 1 1.5 24m28.828 4.903a2 2 0 1 1 3.344 2.194C31.476 34.443 27.647 36 24 36s-7.476-1.556-9.672-4.903a2 2 0 1 1 3.344-2.194C18.976 30.89 21.397 32 24 32s5.024-1.11 6.328-3.097M17 15a2 2 0 0 1 2 2v2a2 2 0 1 1-4 0v-2a2 2 0 0 1 2-2m12 2a2 2 0 1 1 4 0v2a2 2 0 1 1-4 0z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default chatBubbleOvalSmiley1Solid
